import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  Chip,
  Theme,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ShowMore } from "components/shared/show-more";
import { DemoItem } from "./demos-page";

export const DemoCard = (props: DemoItem) => {
  const classes = useStyles();

  return (
    <Card className={classes.item}>
      <CardActionArea
        href={props.path}
        disabled={!props.public}
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <CardMedia
          sx={{ height: 250, width: 250 }}
          component="img"
          src={props.thumbnail}
        />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              padding: 2,
              justifyContent: "space-between",
              alignItems: "baseline",
            }}
          >
            <CardHeader
              sx={{
                padding: 0,
              }}
              title={props.title}
            ></CardHeader>
            <Typography variant="body1">{props.type}</Typography>
          </Box>
          <CardContent sx={{ flexGrow: 1 }}>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
            >
              <Box sx={{ width: "150px", display: "flex", gap: "8px" }}>
                {props.categories.map((type: any) => (
                  <Chip label={type} color="primary" size="small" />
                ))}
              </Box>
            </Box>
            <ShowMore lines={3} showButton={false}>
              <Typography variant="body2">{props.description}</Typography>
            </ShowMore>
          </CardContent>
        </Box>
      </CardActionArea>
    </Card>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  item: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    "&:hover": {
      background: "theme.palette.action.hover",
    },
  },
}));